import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import RichTextEditor from 'react-rte';
import { OrganizationContext } from '../../../Services/OrganizationContext';
import authService from '../../../Services/authService';
import { useNavigate } from 'react-router-dom';
import { Table, Button, Space } from 'antd';
import Trash from '../../Assets/images/recycle-bin.png';
import Plus from '../../Assets/images/plus.png';
import TabMenu from './TabMenu';
import Breadcrumb from "../Breadcrumb/Breadcrumb";

const AddPackages = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [catorgbasedtests, setCatorgBasedTests] = useState([]);
  const { organization } = useContext(OrganizationContext);
  const [editorState, setEditorState] = useState(RichTextEditor.createEmptyValue());
  // const [packageTests, setPackageTests] = useState([{ category_id: '', lab_test_id: '' }]);
  const [formData, setFormData] = useState({
    package_name: '',
    description: '',
    price: '',
    preparation: '',
    mrp_price: '',
    organization_id: organization ? organization.id : '',
    Is_Active: '',
    visit_type: '', // Use a string or number for radio values
    genderwiseid: '', // Use a string or number for radio values
    keywords: '',
  });
  const [errors, setErrors] = useState("");
  const [packageTests, setPackageTests] = useState([
    { category_name: '', lab_tests: [{ labtest_name: '' }] }
  ]);
  const [rcheckups, setRcheckups] = useState([]);


  const ValidateForm = () => {
    const errors = {};
    const priceRegex = /^[0-9]+$/;

    if (!formData.package_name) {
      errors.package_name = 'Package Name is required';
    }

    if (!formData.price) {
      errors.price = 'Offer Price is required';
    } else if (!priceRegex.test(formData.price)) {
      errors.price = 'Offer Price must contain only numbers';
    }

    if (!formData.mrp_price) {
      errors.mrp_price = 'MRP Price is required';
    } else if (!priceRegex.test(formData.mrp_price)) {
      errors.mrp_price = 'MRP Price must contain only numbers';
    }

    if (!formData.description) {
      errors.description = 'Description is required';
    }

    packageTests.forEach((test, index) => {
      if (!test.category_name || test.category_name.trim() === '') {
        errors[`category_name_${index}`] = 'Category Name is required';
      }

      test.lab_tests.forEach((labTest, labIndex) => {
        if (!labTest.labtest_name || labTest.labtest_name.trim() === '') {
          errors[`labtest_name_${index}_${labIndex}`] = 'Lab Test Name is required';
        }
      });
    });

    if (!formData.visit_type) {
      errors.visit_type = 'Visit type is required';
    }

    if (!formData.genderwiseid) {
      errors.genderwiseid = 'Recommended Gender/Age is required';
    }

    return errors;
  };


  useEffect(() => {
    if (organization) {
      loadCategories();
      loadcheckups();
    }
  }, [organization]);

  const loadcheckups = () => {
    const token = authService.getCurrentadmin().token; // Retrieve the token for authorizationauthorization // Retrieve the token for authorization

    // Construct the URL with the organization_id as a query parameter
    const url = new URL(authService.getApiUrl() + "genderwiseages");
    //url.searchParams.append("organization_id", organization); // Append the organization_id as a query parameter

    fetch(url, {
      method: "GET", // Set method to GET
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${token}`, // Include Authorization header with Bearer token if required
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setRcheckups(result.data); // Set the category data in state
      })
      .catch((err) => {
        console.log(err.message); // Handle any errors
      });
  };


  const loadCategories = async () => {
    const token = authService.getCurrentadmin().token;
    const url = new URL(authService.getApiUrl() + 'category');
    url.searchParams.append('organization_id', organization);

    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setCategories(result.data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const loadLabTests = (categoryId, index) => {
    const token = authService.getCurrentadmin().token;

    fetch(authService.getApiUrl() + 'catorgbasedtests', {
      method: 'POST',
      body: JSON.stringify({ organization_id: organization, category_id: categoryId }),
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        const updatedTests = [...catorgbasedtests];
        updatedTests[index] = result.data;
        setCatorgBasedTests(updatedTests);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handlePackageTestChange = (index, field, value) => {
    const updatedPackageTests = [...packageTests];
    updatedPackageTests[index][field] = value;
    setPackageTests(updatedPackageTests);

    if (field === 'category_name') {
      const selectedCategory = categories.find((c) => c.category_name === value);
      if (selectedCategory) {
        loadLabTests(selectedCategory.id, index);
      }
    }
  };


  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleAddTest = () => {
    setPackageTests([...packageTests, { category_id: '', lab_test_id: '' }]);
    setCatorgBasedTests([...catorgbasedtests, []]);
  };

  const handleRemoveTest = (index) => {
    const updatedPackageTests = [...packageTests];
    updatedPackageTests.splice(index, 1);
    setPackageTests(updatedPackageTests);

    const updatedCatorgBasedTests = [...catorgbasedtests];
    updatedCatorgBasedTests.splice(index, 1);
    setCatorgBasedTests(updatedCatorgBasedTests);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const ValidateErrors = ValidateForm(formData);
    setErrors(ValidateErrors);
    if (Object.keys(ValidateErrors).length === 0) {
      const token = authService.getCurrentadmin().token;

      try {
        const response = await fetch(authService.getApiUrl() + 'labtestpackage', {
          method: 'POST',
          body: JSON.stringify({
            organization_id: organization,
            package_name: formData.package_name,
            description: formData.description,
            price: formData.price,
            mrp_price: formData.mrp_price,
            preparation: formData.preparation,
            // Is_Active: "A", 
            Is_Active: formData.Is_Active ? 'A' : 'I',
            package_tests: packageTests,
            visit_type: formData.visit_type,
            genderwiseid: formData.genderwiseid,
            keywords: formData.keywords,
          }),
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=UTF-8',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to create package');
        }

        const result = await response.json();

        navigate('/admin/lab-management/packages');

      } catch (err) {
        console.log('Error:', err.message);
      }
    }
    else {
      console.log("Form submission failed due to validation errors.");
    }
  };

  const handleCategoryChange = (index, value) => {
    const updated = [...packageTests];
    updated[index].category_name = value;
    setPackageTests(updated);
  };

  const handleLabTestChange = (catIndex, labIndex, value) => {
    const updated = [...packageTests];
    updated[catIndex].lab_tests[labIndex].labtest_name = value;
    setPackageTests(updated);
  };

  const addCategory = () => {
    setPackageTests([...packageTests, { category_name: '', lab_tests: [{ labtest_name: '' }] }]);
  };

  const removeCategory = (index) => {
    const updated = [...packageTests];
    updated.splice(index, 1);
    setPackageTests(updated);
  };

  const addLabTest = (catIndex) => {
    const updated = [...packageTests];
    updated[catIndex].lab_tests.push({ labtest_name: '' });
    setPackageTests(updated);
  };

  const removeLabTest = (catIndex, labIndex) => {
    const updated = [...packageTests];
    updated[catIndex].lab_tests.splice(labIndex, 1);
    setPackageTests(updated);
  };

  return (
    <>
      <div className='main-container'>
        <div className='container-fluid'>
          <Breadcrumb />
          <TabMenu name="packages" />
          <div className='category-table'>
            <div className='flex-cont add-cat'>
              <div className='heading'>
                <h3>Add Package</h3>
              </div>
            </div>
            <div className="card">
              <div className="card-body custom-edit-service">
                <form className="needs-validation clearfix" onSubmit={handleSubmit} key="addform">
                  <div className="addtest-fields mb-3">
                    <div className="flex-cont">
                      <div className="full-cont">
                        <div className="form-group">
                          <label>
                            Package Name
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="package_name"
                            id="package_name"

                            value={formData.package_name}
                            onChange={handleInputChange}
                          />
                          {errors.package_name && <span className='errors' >{errors.package_name}</span>}
                        </div>
                      </div>
                      {packageTests.map((category, catIndex) => (

                        < >
                          <div className="row-cont add-packages-set" key={catIndex}>
                            <div className="full-cont package-full-cont">
                              <div className="form-group">
                                <label>
                                  Category Name <span className="text-danger">*</span>
                                </label>
                                <input
                                  className="form-control"
                                  type="text"
                                  value={category.category_name}
                                  onChange={(e) => handleCategoryChange(catIndex, e.target.value)}
                                />
                                {errors[`category_name_${catIndex}`] && (
                                  <span className='errors'>{errors[`category_name_${catIndex}`]}</span>
                                )}
                              </div>
                            </div>
                            <div className="action-icon">
                              <Button
                                type="text"
                                icon={<img src={Plus} alt="Add" style={{ width: 18, height: 18 }} />}
                                onClick={addCategory}
                              />
                            </div>
                            <div className="action-icon">
                              <Button
                                type="text"
                                icon={<img src={Trash} alt="Delete" style={{ width: 18, height: 18 }} />}
                                onClick={() => removeCategory(catIndex)}
                              />
                            </div>
                          </div>
                          {category.lab_tests.map((labTest, labIndex) => (
                            <div className="row-cont add-packages-set" key={labIndex} >
                              <div className="half-cont package-half-cont">
                                <div className="form-group">
                                  <label>
                                    Lab Test Name <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={labTest.labtest_name}
                                    onChange={(e) => handleLabTestChange(catIndex, labIndex, e.target.value)}
                                  />
                                  {errors[`labtest_name_${catIndex}_${labIndex}`] && (
                                    <span className='errors'>{errors[`labtest_name_${catIndex}_${labIndex}`]}</span>
                                  )}
                                </div>
                              </div>
                              <div className="action-icon">
                                <Button
                                  type="text"
                                  icon={<img src={Plus} alt="Add" style={{ width: 18, height: 18 }} />}
                                  onClick={() => addLabTest(catIndex)}
                                />
                              </div>
                              <div className="action-icon">
                                <Button
                                  type="text"
                                  icon={<img src={Trash} alt="Delete" style={{ width: 18, height: 18 }} />}
                                  onClick={() => removeLabTest(catIndex, labIndex)}
                                />
                              </div>
                            </div>
                          ))}
                        </>
                      ))}




                      <div className="full-cont">
                        <div className="form-group">
                          <label>
                            Description
                            <span className="text-danger">*</span>
                          </label>
                          <textarea
                            className="form-control"
                            placeholder="Enter message"
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            rows="4"
                          />
                          {errors.description && <span className='errors' >{errors.description}</span>}
                        </div>
                      </div>
                      <div className="half-cont">
                        <div className="form-group row">
                          <label>
                            Offer Price
                            <span className="text-danger">*</span>
                          </label>
                          <div className="inline-flex">
                            <span className="input-group-text">&#8377;</span>
                            <input
                              type="text"
                              className="form-control"
                              name="price"
                              value={formData.price}
                              onChange={handleInputChange}
                            />
                            <span className="input-group-text">.00</span>
                          </div>
                          {errors.price && <span className='errors' >{errors.price}</span>}
                        </div>
                      </div>
                      <div className="half-cont">
                        <div className="form-group row">
                          <label>
                            MRP Price
                            <span className="text-danger">*</span>
                          </label>
                          <div className="inline-flex">
                            <span className="input-group-text">&#8377;</span>
                            <input
                              type="text"
                              className="form-control"
                              name="mrp_price"
                              value={formData.mrp_price}
                              onChange={handleInputChange}
                            />
                            <span className="input-group-text">.00</span>
                          </div>
                          {errors.mrp_price && <span className='errors' >{errors.mrp_price}</span>}
                        </div>
                      </div>
                      <div className="half-cont">
                        <div className="form-group">
                          <label>
                            Preparation
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter message"
                            name="preparation"
                            value={formData.preparation}
                            onChange={handleInputChange}
                          />
                          {errors.preparation && <span className='errors' >{errors.preparation}</span>}
                        </div>
                      </div>
                      <div className="half-cont">
                        <div className="form-group">
                          <label>
                            Recommended Gender/Age <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select form-control"
                            name="genderwiseid"
                            // required
                            value={formData.genderwiseid}
                            onChange={handleInputChange}
                          >
                            <option value="">--Select--</option>
                            {rcheckups.map((item, i) => (
                              <option value={item.id} key={i}>{item.gender} - {item.age}</option>
                            ))}
                          </select>
                          {errors.genderwiseid && <span className='errors' >{errors.genderwiseid}</span>}
                        </div>
                      </div>
                    </div>

                    <div className="full-cont">
                      <div className="form-group">
                        <label>
                          Keywords
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter message"
                          name="keywords"
                          value={formData.keywords}
                          onChange={handleInputChange}
                        />
                        {errors.keywords && <span className='errors' >{errors.keywords}</span>}
                      </div>
                    </div>

                    <div className="half-cont">
                      <div className="form-group">
                        <label>Visit Type
                          <span className="text-danger">*</span>
                        </label>
                        <div className='radio-sec'>
                          <div className='radio-btn'>
                            <label>
                              <input
                                type="radio"
                                name="visit_type"
                                value="1"
                                checked={formData.visit_type === '1'}
                                onChange={handleInputChange}
                              />
                              Home Visit
                            </label>
                          </div>
                          <div className='radio-btn'>
                            <label>
                              <input
                                type="radio"
                                name="visit_type"
                                value="2"
                                checked={formData.visit_type === '2'}
                                onChange={handleInputChange}
                              />
                              Hospital Visit
                            </label>
                          </div>

                        </div>
                        {errors.visit_type && <span className='errors' >{errors.visit_type}</span>}
                      </div>
                    </div>

                    <div className="flex-cont">
                      {/* Radio buttons for Home and Hospital Visit */}
                      <div className="full-cont special-case-cont">
                        <div className='form-group'>
                          <label className="custom-checkbox">
                            <input
                              type="checkbox"
                              name="Is_Active"
                              checked={formData.Is_Active}
                              onChange={handleInputChange}
                              value="A"

                            />
                            <span className="checkmark"></span>
                            <label>Status</label>
                          </label>
                          {/* {errors.Is_Active && <span className='errors' >{errors.Is_Active}</span>} */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="submit-section">
                    <button
                      className="btn btn-primary submit-btn"
                      type="submit"

                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPackages;

